<template>
    <span class="translate ltr" :class="[{ 'disabled': disabled }]" @click.prevent="click">{{ _value }}</span>
    <input :class="[{ 'has': value && base.Util().validate(String(value)) }]" v-model="value" :readonly="true"
        :disabled="true" hidden>
    <DatePicker v-if="!disabled" :id="`vpd-${this.id}`" type="datetime" compact-time auto-submit simple v-model="value">
    </DatePicker>
</template>

<script>
import DatePicker from 'vue3-persian-datetime-picker'
import moment from 'moment-jalaali'

/* eslint-disable */
export default {
    name: 'DateTime',
    props: ['meta', 'vm', 'disabled'],
    inject: ['base'],
    components: { DatePicker },
    created() {
    },
    data() {
        return {
            id: this.base.Util().hash(4),
            value: this.vm || '',
            hint: '',
            error: false,
            _value: this.value
                ? moment.unix((Number(this.value) / 1000)).format(`jYYYY/jMM/jDD HH:mm`)
                : ''
        }
    },
    watch: {
        vm(newVM, oldVM) {
            if (this.value !== this.vm) {
                this.value = moment.unix((Number(this.vm) / 1000)).format(`jYYYY/jMM/jDD HH:mm`)
                this.hint = ''
            }
        },
        value() {
            let value = moment(this.value, 'jYYYY/jMM/jDD HH:mm').valueOf()
            this._value = moment.unix((Number(value) / 1000)).format(`jYYYY/jMM/jDD HH:mm`)

            this.$emit('onchange', {
                value: String(value),
                hint: this.hint,
                error: this.error
            })
        }
    },
    methods: {
        click() {
            if (!this.disabled)
                document?.getElementById(`vpd-${this.id}`)?.getElementsByTagName('label')[0]?.click()
        }
    }
}
</script>